import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "~/Core/Components/shadcn/ui/sheet";

export function Privacy() {
  return (
    <Sheet>
      <SheetTrigger asChild>
        <a role="button">Privacy Notice</a>
      </SheetTrigger>
      <SheetContent className="top-0 max-w-[480px] bg-neutrals-pale-sand p-0  outline-none">
        <div className="grid flex-1 auto-rows-min gap-0  overflow-y-auto max-h-[100%]">
          <SheetHeader className="py-10  px-12 sticky top-0 bg-neutrals-pale-sand ">
            <SheetTitle className="!text-larg-medium text-primary-darkest-green !leading-9">Musahama’s Privacy Notice</SheetTitle>
          </SheetHeader>
          <hr className="m-0" />
          <div
            className=" px-12   prose prose-p:text-small-light prose-li:text-small-light prose-p:text-secondary-dark-grey 
          prose-h2:text-secondary-darkest-grey prose-h2:text-regular-regular prose-h2:mt-9">
            <section>
              <h2>Introduction</h2>
              <p>
                This Privacy Notice describes how the Public Investment Fund’s (“PIF”) Musahama Platform (“Platform”) collects, uses and discloses
                personal information. The Platform is committed to respecting and protecting your personal or sensitive personal in accordance with
                the laws and regulations in force in the Kingdom of Saudi Arabia. The Platform will only use the personal information to deliver the
                required services. This Privacy Notice applies to all visitors and users, (hereinafter referred to as “you”) who access or use the
                Platform. The intent of this Privacy Notice is to inform you about the following:
              </p>
              <ul>
                <li>The type of information the Platform may gather and the purpose for gathering it when you use the Platform.</li>
                <li>The use of the personal information gathered from you and who do we share it with.</li>
                <li>The rights in regard to personal data you share.</li>
              </ul>
            </section>

            <section>
              <h2>Personal Data Collection</h2>
              <p>
                We may collect and obtain the following types of information, when you interact with the Platform, write to or when you upload files
                and data to the Platform: Information you give us: the Platform may collect the personal data directly from you or about you, such as
                the data you have submitted during the registration process and messages you send and receive on this Platform, or personal data about
                others (which may include information about contractors, service providers, consultants and employees…etc.), as part of/required for
                providing services on the Platform. This may include emails, phone numbers, professional positions, first name, last name, CVs, birth
                date, nationality, or any other personal information provided by you to us through the Platform. Nonetheless, by providing personal
                data about others, such as contracts or service provider, you confirm that you have the necessary authority or consent to share such
                data with us. Information collected automatically: the Platform may automatically collect certain personal information that your
                browser sends whenever you visit the Platform such as information collected through cookies or other tracking technologies.
              </p>
            </section>

            <section>
              <h2>Personal Data Usage</h2>
              <p>The Platform may use personal data collected directly or indirectly from you to provide its services, such as:</p>
              <ul>
                <li>Perform quality checks and enhance the services the Platform provides.</li>
                <li>
                  Create an account, if required, whereby you can login through a username and password to access the various services provided on the
                  Platform.
                </li>
                <li>Resolving any queries you submit that require making your personal data accessible to authorized members of the support team.</li>
                <li>Comply with legal and regulatory obligations.</li>
              </ul>
            </section>

            <section>
              <h2>Personal Data Disclosure</h2>
              <p>
                The Platform will not share your information with third parties for marketing purposes. The Platform reserves the right to disclose
                your personal data in any of the following cases:
              </p>
              <ul>
                <li>You have agreed to disclose your personal data.</li>
                <li>The personal data is collected from a publicly available source.</li>
                <li>
                  The entity requesting disclosure is a public entity and the request is for security purposes, to implement another law, or to meet
                  judicial requirements in accordance with the provisions set out by the regulations.
                </li>
                <li>
                  The disclosure is necessary to protect public health or safety, or to protect the life or health of a particular individual(s).
                </li>
                <li>The disclosure will not lead to your identification or any other individuals.</li>
                <li>The disclosure is necessary to achieve legitimate interests of the Platform without prejudice to your rights and interests.</li>
              </ul>
            </section>

            <section>
              <h2>Legal Basis for Processing Personal Data</h2>
              <p>The following are the lawful bases for processing personal data:</p>
              <ul>
                <li>
                  Your consent that you provide to process your personal information for a specific purpose that the Platform communicates to you.
                </li>
                <li>
                  We may process personal data without obtaining consent in the following cases:
                  <ul>
                    <li>If the processing achieves a definite interest for you and it is impossible or difficult to contact you.</li>
                    <li>
                      If processing is according to an initial contractual agreement with you, or processing is in accordance with applicable laws.
                    </li>
                    <li>If the processing required for judicial and/or security purposes by a public entity.</li>
                    <li>If the personal data is publicly available or collected from a publicly available source.</li>
                  </ul>
                </li>
                <li>Pursuing legitimate interest for the Platform or for you.</li>
                <li>Compliance with laws and regulations.</li>
                <li>Protecting the vital interest of individuals.</li>
                <li>Achieving public interest or serving an official request from an authority according to its roles.</li>
                <li>Executing an agreement in which you are a party.</li>
              </ul>
            </section>

            <section>
              <h2>Your Rights</h2>
              <p>
                The Platform takes all reasonable efforts to guarantee your rights under the limits stipulated in the applicable laws and regulations
                of the Kingdom of Saudi Arabia, as follows:
              </p>
              <ul>
                <li>
                  Be Informed: You have the right to be informed about the collection and usage of your personal data including why and how the
                  Platform collects your personal data, the purposes for processing your data, and who will it be shared with.
                </li>
                <li>
                  Request Access: You have the right to access your personal data used in connection with the Platform in a readable and clear format
                  and are entitled to obtain a copy of it. The Platform may also restrict this request as per the cases stipulated in the Personal
                  Data Protection Law.
                </li>
                <li>Update: You have the right to request data correction, completion, or update.</li>
                <li>
                  Request Destruction: You have the right to request that your personal data be destroyed when:
                  <ul>
                    <li>You consider that the Platform no longer require the information for the purposes for which it was obtained.</li>
                    <li>You have validly objected to our use of your personal information.</li>
                    <li>Our use of your personal information is contrary to the Law or any other legal obligations.</li>
                    <li>You have revoked your consent to collect and process your personal data.</li>
                  </ul>
                </li>
                <li>
                  Withdraw Consent: You have the right to revoke consent to collect and process your personal data unless statutory or judicial
                  requirements require otherwise.
                </li>
                <li>
                  File a Complaint: You have the right to file complaint to the competent authority when you feel that your rights have not been met.
                </li>
              </ul>
              <p>You may submit a request to exercise your rights by filling out the [Request form].</p>
            </section>

            <section>
              <h2>Personal Data Storage, Retention, and Destruction</h2>
              <p>
                Personal data is stored on servers [e.g., owned by the PIF, and a third party, such as cloud service providers (whether inside or
                outside the Kingdom)], may be engaged for data storage. PIF employs best-in-class technologies in accordance with the regulations of
                the National Cybersecurity Authority and international standards to ensure the security of personal data, prevent unauthorized access,
                and mitigate cybersecurity risks. Additionally, personal data is stored only as long as is necessary to fulfil the purposes for which
                it was collected and destroyed once the purpose has been fulfilled unless retention of personal data is required for a longer period
                to comply with another law or legal purpose such as compliance with a court order or under the rules and regulations in which we
                subject to.
              </p>
            </section>

            <section>
              <h2>Personal Data Security</h2>
              <p>
                The Platform takes appropriate measures to protect and safeguard your personal data against accidental, unlawful, or unauthorized
                destruction, loss, alteration, access, disclosure, or use. However, please be aware that no method of transmission over the internet
                is completely secure. While the Platform strives to use industry-standard measures to protect your personal data, the Platform cannot
                guarantee its absolute security. In the unlikely event of a data breach, the Platform is committed to following all applicable data
                breach notification laws. The security measures are reviewed periodically by us to keep pace with security and regulatory changes.
              </p>
            </section>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
